import { render, staticRenderFns } from "./EditSchoolsComponents.vue?vue&type=template&id=8951a860"
import script from "./EditSchoolsComponents.vue?vue&type=script&lang=js"
export * from "./EditSchoolsComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports